class VersionChecker {
  constructor() {
    this.currentVersion = null;
    this.checkInterval = null;
    this.isChecking = false;
    this.onUpdateAvailable = null;
    this.checkIntervalTime = 30 * 60 * 1000; // Check every 30 minutes
    this.retryCount = 0;
    this.maxRetries = 3;
  }

  async getCurrentVersion() {
    console.log('Getting current version');
    try {
      const response = await fetch('/version.json?' + new Date().getTime(), {
        cache: 'no-cache',
        headers: {
          'Cache-Control': 'no-cache'
        }
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      return data;
    } catch (error) {
      console.warn('Failed to fetch version info:', error);
      return null;
    }
  }

  async checkForUpdates() {
    if (this.isChecking) return;
    
    this.isChecking = true;
    
    try {
      const versionInfo = await this.getCurrentVersion();
      
      if (!versionInfo) {
        this.retryCount++;
        if (this.retryCount < this.maxRetries) {
          console.log(`Version check failed, retrying... (${this.retryCount}/${this.maxRetries})`);
          setTimeout(() => this.checkForUpdates(), 10000); // Retry in 10 seconds
        }
        return;
      }

      // Reset retry count on successful fetch
      this.retryCount = 0;

      // First time checking - store current version
      if (!this.currentVersion) {
        this.currentVersion = versionInfo;
        console.log('Version checker initialized with version:', versionInfo.version);
        return;
      }

      // Check if version has changed
      if (this.hasVersionChanged(this.currentVersion, versionInfo)) {
        console.log('New version detected:', versionInfo.version);
        if (this.onUpdateAvailable) {
          this.onUpdateAvailable(versionInfo);
        }
      }
    } catch (error) {
      console.error('Error checking for updates:', error);
    } finally {
      this.isChecking = false;
    }
  }

  hasVersionChanged(oldVersion, newVersion) {
    return oldVersion.version !== newVersion.version || 
           oldVersion.buildTime !== newVersion.buildTime;
  }

  startChecking(onUpdateCallback) {
    this.onUpdateAvailable = onUpdateCallback;
    
    // Initial check
    this.checkForUpdates();
    
    // Start periodic checking
    this.checkInterval = setInterval(() => {
      this.checkForUpdates();
    }, this.checkIntervalTime);

    console.log('Version checker started');
  }

  stopChecking() {
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
      this.checkInterval = null;
      console.log('Version checker stopped');
    }
  }

  forceRefresh() {
    // Clear all caches and reload
    if ('caches' in window) {
      caches.keys().then(names => {
        names.forEach(name => {
          caches.delete(name);
        });
      });
    }
    
    // Force reload without cache
    window.location.reload(true);
  }
}

export default new VersionChecker(); 